<ion-content class="onboarding-content" [scrollY]="false">
  <div class="onboarding-layout">

    <!-- HEADER -->
    <div class="onboarding-header">
      <ion-icon name="heart-outline" class="onboarding-header__icon" aria-hidden="true"></ion-icon>
      <h1 class="onboarding-header__title">Personalizza la tua esperienza</h1>
      <p class="onboarding-header__subtitle">Seleziona almeno un interesse per continuare</p>
    </div>

    <!-- BODY -->
    <div class="onboarding-body">

      @if (loading) {
        <div class="onboarding-center">
          <ion-spinner name="crescent" class="onboarding-spinner"></ion-spinner>
          <p class="onboarding-center__text">Caricamento interessi...</p>
        </div>
      } @else if (loadError) {
        <div class="onboarding-center">
          <ion-icon name="refresh-outline" class="onboarding-center__icon" aria-hidden="true"></ion-icon>
          <p class="onboarding-center__text">Impossibile caricare gli interessi.</p>
          <button type="button" class="onboarding-btn onboarding-btn--outline" (click)="loadInterests()">
            Riprova
          </button>
          <button type="button" class="onboarding-btn onboarding-btn--text" (click)="exitApp()">
            <ion-icon name="log-out-outline" aria-hidden="true"></ion-icon>
            Esci
          </button>
        </div>
      } @else {
        <div class="interests-grid" role="group" aria-label="Seleziona i tuoi interessi">
          @for (item of interests; track item.id) {
            <button
              type="button"
              class="interest-card"
              [class.interest-card--selected]="isSelected(item)"
              [attr.aria-pressed]="isSelected(item)"
              (click)="toggle(item)"
            >
              @if (isSelected(item)) {
                <ion-icon name="checkmark-circle" class="interest-card__check" aria-hidden="true"></ion-icon>
              }
              <span class="interest-card__label">{{ item.nome }}</span>
            </button>
          }
        </div>
      }

    </div>

    <!-- FOOTER -->
    @if (!loading && !loadError) {
      <div class="onboarding-footer">
        <button
          type="button"
          class="onboarding-btn onboarding-btn--primary"
          [disabled]="!hasSelection || saving"
          (click)="save()"
        >
          @if (saving) {
            <ion-spinner name="crescent" class="btn-spinner"></ion-spinner>
          } @else {
            Continua{{ hasSelection ? ' (' + selectionCount + ')' : '' }}
          }
        </button>
      </div>
    }

  </div>
</ion-content>
